import styled from 'styled-components';

export const StyledMoneyBack = styled.div`
  margin-top: ${props => props.theme.spacing(4)};
  @media ${props => props.theme.laptop} {
    margin-top: ${props => props.theme.spacing(8)};
  }
`;

export const Headline = styled.h1`
  ${props => props.theme.typography.heading5}
  margin-bottom: ${props => props.theme.spacing(1)};
`;

export const Description = styled.span`
  ${props => props.theme.typography.body3}
`;

export const HeadlineContainer = styled.div`
  display: flex;
  margin-bottom: ${props => props.theme.spacing(6)};
`;

export const HeadlineContent = styled.div`
  display: inline-block;
  margin-left: ${props => props.theme.spacing(6)};
`;

export const Line = styled.hr`
  border: 1px solid ${props => props.theme.colors.border.base};
  opacity: 0.4;
  margin-bottom: ${props => props.theme.spacing(6)};
`;

export const IconContainer = styled.div`
  height: 74px;
  width: 64px;
`;
